import { axios } from '@Root/API'

export const getAll = (contactId, params) => {
	return axios.get(`contacts/${contactId}/engagement`, { params })
}
